import Button, { type ButtonProps } from "@client/controls/Button/component";
import { FormStyleContext } from "@common/contexts/FormStyle";
import classNames from "classnames";
import React from "react";

type SecondaryButtonProps = Omit<ButtonProps, "iconClassName"> & {
  icon?: string;
  tooltip?: string;
};

export const SecondaryButton = ({ icon, ...props }: SecondaryButtonProps) => {
  const { secondaryButtonStyle } = React.useContext(FormStyleContext);

  const style = React.useMemo(
    () => ({
      ...secondaryButtonStyle,
      ...props.style
    }),
    [props.style, secondaryButtonStyle]
  );

  return <Button {...props} className={classNames("btn-light", props.className)} iconClassName={icon} style={style} />;
};
